import React, { useCallback } from 'react';
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from 'react-icons/md';
import ReactLoader from 'react-loading';
import { SlideDown } from 'react-slidedown';

import moment from 'moment';
import { ColorPalette } from 'theme/colors';

import useStoreTranslation from 'hooks/useStoreTranslation';
import { CancellationPolicies as CancellationPoliciesModel } from 'models/cancellationPolicies';
import { getFormattedPrice } from 'utils/currency';
import { htmlT } from 'utils/generic';

import { DetailCard, SubTitle, Info, SeeMore, LoadingContainer } from './styles';

interface Props {
  data: CancellationPoliciesModel[];
  show: boolean;
  isFetching?: boolean;
  onClick?: () => void;
}

const CancellationPolicies = ({ isFetching, data, show, onClick }: Props) => {
  const { t } = useStoreTranslation();

  const formatDate = (date: string) => moment.utc(date).format('DD/MM/YYYY');
  const formatHours = (date: string) => moment.utc(date).format('HH');
  const formattedPrice = useCallback(
    (item: CancellationPoliciesModel) => {
      const { formatted } =
        item.amount && item.amount.fare
          ? getFormattedPrice({ value: item?.amount?.fare, currency: item?.amount?.currencyCode, t })
          : getFormattedPrice({ value: 0, currency: undefined, t });
      return formatted;
    },
    [t],
  );

  const getTextCancellationPolicies = (item: CancellationPoliciesModel) => {
    const isMinDate =
      item.dateFromGmtAgency &&
      new Date(item.dateFromGmtAgency).getFullYear() <= 1;

  const content = isMinDate
    ? item.cancellationText
    : htmlT(t, 'hotelDetails.cancellationPoliciesInfo', {
        hours: formatHours(item.dateFromGmtAgency ?? item.dateFrom),
        date: formatDate(item.dateFromGmtAgency ?? item.dateFrom),
        price: item && item.amount ? formattedPrice(item) : 0,
      });

  return <p>{content}</p>;
  }

  return (
    <DetailCard>
      <SeeMore type="button" onClick={onClick ? onClick : () => {}}>
        <SubTitle>{t('hotelDetails.cancellationPolicies')}</SubTitle>
        {show ? <MdKeyboardArrowUp size={26} /> : <MdKeyboardArrowDown size={26} />}
      </SeeMore>
      <SlideDown closed={!show}>
        {isFetching ? (
          <LoadingContainer>
            <ReactLoader type="spin" color={ColorPalette.HEX.Gainsboro} width={30} height={30} />
          </LoadingContainer>
        ) : (
          (data || []).map((item, i) => (
            <Info key={i}>
              <SubTitle>{htmlT(t, 'hotelDetails.cancellationPoliciesInfoTitle', { count: i + 1 })}</SubTitle>
              {getTextCancellationPolicies(item)}
            </Info>
          ))
        )}
      </SlideDown>
    </DetailCard>
  );
};

export default CancellationPolicies;
